import { render, staticRenderFns } from "./HelpfulList.vue?vue&type=template&id=29b9538f&scoped=true"
import script from "./HelpfulList.vue?vue&type=script&lang=js"
export * from "./HelpfulList.vue?vue&type=script&lang=js"
import style0 from "./HelpfulList.vue?vue&type=style&index=0&id=29b9538f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b9538f",
  null
  
)

export default component.exports